<script lang="ts">
  import { Router, Route } from 'svelte-routing';
  import Header from '$lib/components/Header.svelte';
  import Footer from '$lib/components/Footer.svelte';
  import Home from './routes/Home.svelte';
  import About from './routes/About.svelte';
  import Privacy from './routes/Privacy.svelte';
  import Progress from './routes/Progress.svelte';
  import SignupConfirmed from './routes/SignupConfirmed.svelte';
  import SignupNotFound from './routes/SignupNotFound.svelte';
  import Unsubscribed from './routes/Unsubscribed.svelte';
  import UnsubscribeFailed from './routes/UnsubscribeFailed.svelte';
  import Feedback from './routes/Feedback.svelte';
  import NotFound from './routes/NotFound.svelte';

  import { onMount } from 'svelte';
  
  let isLoading = true;
  let currentPath = '/';
  
  onMount(() => {
    setTimeout(() => {
      isLoading = false;
    }, 100);
    
    // Track current path for header styling
    currentPath = window.location.pathname;
    const handleNavigation = () => {
      currentPath = window.location.pathname;
    };
    window.addEventListener('popstate', handleNavigation);
    
    // Also listen for link clicks that use history API
    const observer = new MutationObserver(() => {
      if (currentPath !== window.location.pathname) {
        currentPath = window.location.pathname;
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    return () => {
      window.removeEventListener('popstate', handleNavigation);
      observer.disconnect();
    };
  });
  
  $: isFrontPage = currentPath === '/';
</script>

<Router url="">
  <div class:is-loading={isLoading}>
    <Header {isFrontPage} />
    
    <a id="main" title="Main area"></a>
    <div id="wrapper">
      <Route path="/"><Home on:navigate={() => currentPath = window.location.pathname} /></Route>
      <Route path="/about"><About /></Route>
      <Route path="/privacy"><Privacy /></Route>
      <Route path="/:year/:month" let:params><Progress year={params.year} month={params.month} /></Route>
      <Route path="/signup-confirmed"><SignupConfirmed /></Route>
      <Route path="/signup-not-found"><SignupNotFound /></Route>
      <Route path="/unsubscribed"><Unsubscribed /></Route>
      <Route path="/unsubscribe-failed"><UnsubscribeFailed /></Route>
      <Route path="/feedback"><Feedback /></Route>
      <Route><NotFound /></Route>
      <Footer showNav={!isFrontPage} />
    </div>
  </div>
</Router>
